<template>
    <ValidationObserver ref="observer" v-slot="{ passes }">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Покупка билетов</p>
            </header>
            <section class="modal-card-body">
                <validation-provider rules="required|email"
                                     v-slot="{ errors, valid }" name="Email">
                    <b-field
                            label="Email"
                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                            :message="errors">
                        <b-input v-model="form.email" type="email"/>
                    </b-field>
                </validation-provider>
                <hr>
                <b-field>
                    <b-checkbox v-model="form.subscribe">Подписаться на новости</b-checkbox>
                </b-field>

                <validation-provider name="Согласие"
                                     rules="required" v-slot="{ errors }">
                    <b-field>
                        <div class="block">
                            <b-checkbox v-model="form.agreement" native-value="agreement">
                                Я понимаю, что для посещения Государственного Кремлевского
                                Дворца, необходимо
                                распечатать билет на бумажном носителе.
                            </b-checkbox>
                            <p class="help has-text-danger">{{ errors[0] }}</p>
                        </div>
                    </b-field>

                </validation-provider>
            </section>
            <footer class="modal-card-foot">
                <button :disabled="loading" class="button" type="button" @click="$parent.close()">Закрыть</button>
                <button v-bind:class="[{'is-loading':loading},'button', 'is-primary']" @click="passes(submit)">Оплатить</button>
            </footer>
        </div>
    </ValidationObserver>
</template>

<script>
    import {ValidationObserver} from "vee-validate";

    import {mapGetters, mapState} from 'vuex'

    export default {
        name: "ModalFormData",
        components: {
            ValidationObserver
        },
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                    subscribe: true,
                    agreement: [],
                }
            }
        },
        computed: {
            ...mapState({
                ticketsCart: state => state.cart.items,
                eventCard: state => state.eventCard,
            }),
            ...mapGetters('cart', {
                cartTotalPrice: 'cartTotalPrice',
                // cartCountTickets: 'cartCountTickets'
            })
        },
        methods: {
            submit() {
                console.log("Form submitted yay!");
                this.loading = true;

                let sendDate = {
                    vendor: window.location.hostname,
                    event_id: this.eventCard.id,
                    event_name: this.eventCard.name,
                    event_date: this.eventCard.dateTime,
                    places: [],
                    news: this.form.subscribe,
                    email: this.form.email,
                    amount: parseFloat(this.cartTotalPrice)
                };

                this.ticketsCart.forEach(item => {
                  console.log(item);
                    let place = {
                        id: item.id,
                        number: item.number,
                        hall_id: this.eventCard.hallId,
                        section_name: item.sectionName,
                        price: item.price,
                        row: item.titleLine,
                        place: item.name,

                    };
                    sendDate.places.push(place);
                });
                console.log('SendDate', sendDate)

                window.apiKSP.createOrder(sendDate).then(resp => {
                    window.location.href = resp.data.data.payment_url;
                }).catch(e => {
                  this.loading = false;
                    this.$buefy.snackbar.open({
                        duration: 5000,
                        message: e.data.message,
                        type: 'is-danger',
                        position: 'is-bottom-left',
                        queue: false,
                    })
                });
            },
        }
    }
</script>

<style scoped>

</style>
